import { createReducer, on } from '@ngrx/store';
import { clearText } from './input.actions';

export const initialState: {
  clear: boolean;
} = { clear: false };

export const inputReducer = createReducer(
  initialState,
  on(clearText, (state, { doClear }) => {
    return { ...state, clear: doClear };
  })
);
